import React from 'react';

interface NextImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  unoptimized?: boolean;
  priority?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
  fill?: boolean;
  sizes?: string;
  'data-nimg'?: string;
  'data-testid'?: string;
}

const Image = React.forwardRef<HTMLImageElement, NextImageProps>(
  ({ unoptimized, priority, fill, alt, ...props }, ref) => {
    // eslint-disable-next-line @next/next/no-img-element
    return <img ref={ref} alt={alt} {...props} />;
  },
);

Image.displayName = 'Image';

export default Image;
export { Image };
export const getImageProps = (props: NextImageProps) => ({ props });
